import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const EyeIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.125" xmlns="http://www.w3.org/2000/svg"><path d="M11.5633 9.22698C11.5633 10.5365 10.5013 11.5985 9.19179 11.5985C7.88229 11.5985 6.82031 10.5365 6.82031 9.22698C6.82031 7.91673 7.88229 6.85547 9.19179 6.85547C10.5013 6.85547 11.5633 7.91673 11.5633 9.22698Z" /><path d="M2.25 9.2265C2.25 11.6865 5.3565 14.703 9.18897 14.703C13.0207 14.703 16.128 11.6888 16.128 9.2265C16.128 6.76425 13.0207 3.75 9.18897 3.75C5.3565 3.75 2.25 6.7665 2.25 9.2265Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};